import { useEffect } from "react";
import { Helmet } from "react-helmet";

const Pendo = ({ organization, agency, is_internal, t1_user_id }) => {
  useEffect(() => {
    window.pendo_key = process.env.REACT_APP_PENDO_API_KEY;

    const pendoLoader = setInterval(() => {
      if (window.pendo) {
        const userType = is_internal ? "internal" : "external";

        window.pendo.initialize({
          // biome-ignore lint/style/useNamingConvention: 3rd party props
          account: { agency_id: agency, id: organization, user_type: userType },
          visitor: { id: t1_user_id },
        });

        clearInterval(pendoLoader);
      }
    }, 50);

    const pendoTimeout = setTimeout(() => {
      clearInterval(pendoLoader);
    }, 5000);

    return () => {
      clearInterval(pendoLoader);
      clearTimeout(pendoTimeout);
    };
  }, [organization, agency, is_internal, t1_user_id]);

  return (
    <Helmet>
      <script>initPendo(this.pendo_key);</script>
    </Helmet>
  );
};

export default Pendo;
